module.exports = __webpack_public_path__ + "img/campaign2x.7d3e5ec1.png";